<script>
  import { t, lang } from "../i18n";

  function replaceUnitsWitSup(str) {
    return str.replace(/³/g, `<sup style="font-size:0.6em">3</sup>`);
  }

  export let key;
  export let replacements = {};
  $: str = replaceUnitsWitSup(t(key, $lang, replacements));
</script>

<span>{@html str}</span>
